import React from 'react';
import styles from './ORSMSettingsWorkplaceSelectionItem.module.scss';
import { Workplace } from '../../../../graphql/graphql';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	item: Workplace;
	onSelect: (item: Workplace) => void;
}

const ORSMSettingsWorkplaceSelectionItem: React.FC<Props> = ({
	item,
	onSelect,
}) => {
	return (
		<div className={styles.item} onClick={() => onSelect(item)}>
			<div className={styles.content}>
				<div className={styles.title}>{item.doctorDisplayName}</div>
				<Text className={styles.subtitle} tx={item.address?.fullAddress} />
			</div>
			<img src={'/dist/icons/arrow-right-solid-blue.svg'} alt='arrow right' />
		</div>
	);
};

export default ORSMSettingsWorkplaceSelectionItem;
